import React from 'react';
import { v4 as uuid } from 'uuid';

/* Context */
import { VehicleOverviewContext } from 'js/context';

/* Utilities */
import { trans } from 'js/utilities';

export default class VehicleOverviewSearch extends React.Component {
    static contextType = VehicleOverviewContext;

    constructor(props) {
        super(props);

        this.uuid = uuid();
        this.updateQuery = () => { };
    }

    componentDidMount() {
        this.updateQuery = this.context.updateQuery;
    }

    render() {
        const { query = '' } = this.props;

        return (
            <>
                <label htmlFor={this.uuid} className="form-label">{trans('sulu.content_block.vehicle_overview.search.title')}</label>
                <input id={this.uuid} placeholder={trans('sulu.content_block.vehicle_overview.search.placeholder')} type="text" className="form-control form-control--search" value={query} onChange={(event) => {
                    event.persist();
                    this.updateQuery(event.target.value);
                }} />
            </>
        );
    }
}
